import get from "lodash/get";
import React from "react";
import { useSelector } from "react-redux";
import { AlsoRead, Mugshot } from "../../story-elements";
import { isTemplateWithAds } from "../../utils/story";
import { DefaultStoryCard } from "../DefaultStoryCard";
import { WithStoryAds } from "../WithStoryAds";
import AlsoInThisPackage from "./also-in-this-package";
import { BigImage } from "./big-image";
import DetailedQuote from "./detailed-quote";
import FreeAuthorBox from "./free-author-box";
import GnReachFacts from "./gn-reach-facts";
import Highlights from "./highlights";

export default function CustomStoryElement({ card, attribute, story, counter = {} }) {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const hidePackage = get(qtState, ["config", "hidePackage"], false);
  let componentToRender = null;
  switch (attribute) {
    case "Also_Read":
      componentToRender = <AlsoRead card={card} story={story} />;
      break;

    case "Mugshot_Left":
      return <Mugshot card={card} isThumbnailRight={false} story={story} counter={counter} />;

    case "Mugshot_Right":
      return <Mugshot card={card} isThumbnailRight={true} story={story} counter={counter} />;

    case "Detailed_Quote":
      return <DetailedQuote story={story} card={card} counter={counter} />;

    case "Also_In_This_Package":
      componentToRender = !hidePackage && <AlsoInThisPackage story={story} card={card} />;
      break;

    case "Highlights":
      return <Highlights story={story} card={card} counter={counter} />;

    case "Gn_Reach_Facts":
      return <GnReachFacts story={story} card={card} counter={counter} />;

    case "Big_Image":
      componentToRender = <BigImage story={story} card={card} />;
      break;

    case "Free_Author_Box":
      return <FreeAuthorBox story={story} card={card} counter={counter} />;

    default:
      return <DefaultStoryCard card={card} story={story} counter={counter} />;
  }

  const enableParagraphAds = isTemplateWithAds(story);

  return enableParagraphAds ? (
    <WithStoryAds counter={counter} componentToRender={componentToRender} story={story} />
  ) : (
    <>{componentToRender}</>
  );
}
